import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IosDeviceService {
  isIosDevice(): boolean {
    const userAgent = window.navigator.userAgent || window.navigator.vendor || (window as any).opera;
    // iPadOS 13+ identifies as Macintosh; check for touch support
    const isIpadOS = /Macintosh/.test(userAgent) && 'maxTouchPoints' in navigator && (navigator as any).maxTouchPoints > 1;
    // iOS detection: iPhone, iPad, iPod (excluding MacOS)
    const isIos = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    return isIos || isIpadOS;
  }

  addIosClassToHtmlTag(): void {
    if (this.isIosDevice()) {
      document.documentElement.classList.add('ios-device');
    }
  }
}
